import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import "styles/components/UserActionDropDown.scss";
import BlueDownArrow from "img/blue-down-arrow.svg";
import BlueUpArrow from "img/blue-up-arrow.svg.svg";
import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";

const UserActionsDropdown = ({
  module,
  modulePreviewData,
  handleDownloadCMSD,
  downloadCmsdDcoument,
  handleDownloadAnnotationPDF,
  setModuleIdToBeCloned,
  handleViewUnpublishedBusinessRules,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [cloneConfirmOpen, setCloneConfirmOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="user-action-button">
      <Button
        aria-controls="user-actions-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className="userActionBtn"
        disableRipple
        endIcon={
          anchorEl ? (
            <img src={BlueUpArrow} alt="Up Arrow" className="icon" />
          ) : (
            <img src={BlueDownArrow} alt="Down Arrow" className="icon" />
          )
        }
      >
        User Action(s)
      </Button>
      <Menu
        id="user-actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        getContentAnchorEl={null}
        classes={{ paper: "menuPaper" }}
      >
        <MenuItem
          onClick={() => {
            handleDownloadCMSD();
            handleClose();
          }}
          disabled={!module?.mlrStatus || module?.mlrStatus === null}
          className="menuItem"
        >
          Download CMSD - Clean version
        </MenuItem>
        <MenuItem
          onClick={() => {
            downloadCmsdDcoument();
            handleClose();
          }}
          disabled={
            module?.mlrStatus !== "Revise and Resubmit" ||
            module?.cmsdMajorV === null
          }
          className="menuItem"
        >
          Download CMSD - Track changes
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDownloadAnnotationPDF();
            handleClose();
          }}
          disabled={
            !["revise and resubmit"].includes(
              modulePreviewData?.mlrStatus?.toLowerCase()
            )
          }
          className="menuItem"
        >
          Download MLR Feedback
        </MenuItem>
        <MenuItem
          onClick={() => {
            setCloneConfirmOpen(true);
            handleClose();
          }}
          disabled={!module?.mlrStatus}
          className="menuItem"
        >
          {t("module.cloneModule")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleViewUnpublishedBusinessRules();
            handleClose();
          }}
          disabled={!module?.hasUnpublishedBusinessRules}
          className="menuItem"
        >
          View unpublished business rules module
        </MenuItem>
      </Menu>
      <CustomModal
        displayModal={cloneConfirmOpen}
        hideModal={() => setCloneConfirmOpen(false)}
        size="sm"
        dilogClassName="alertModalSmall"
      >
        <ConfirmationPopup
          title={"Make a copy"}
          text={`Local copy of business rules and associated modules linked to ${
            module?.moduleDamName
          } will also be copied. Please consider localizing them as well.`}
          closeModal={() => setCloneConfirmOpen(false)}
          handleConfirm={() => {
            setModuleIdToBeCloned(module.id || module.moduleId);
            setCloneConfirmOpen(false);
          }}
          primaryButtonTitle="PROCEED"
          secondaryButtonTitle="CANCEL"
        />
      </CustomModal>
    </div>
  );
};

export default UserActionsDropdown;
